<!-- splash screen -->
<div #splashScreen id="splash-screen">
   <!-- <img *ngIf="!isReseller" src="../../../../../assets/deployAssets/logo/logo_pequenno.png" alt="" /> -->
   <!-- TODO: ACA DEBERÍA IR UN LOGO ANIMADO DE FACTURACIÓN DEL SII, PUEDE SER ENTRETENIDO-->
   <svg class="splash-spinner" viewBox="0 0 50 50">
      <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
   </svg>
</div>
